import { HasOnComplete, HasOnSuccess } from "@insite/client-framework/HandlerCreator";
import { ApiParameter, get, HasPagingParameters, post } from "@insite/client-framework/Services/ApiService";

const autocompleteUrl = "api/v1/OrderReleaseService/CreateOrderRelease";
const contactUS = "api/v1/OrderReleaseService/CreateOrderRelease";
const getSubscriptionProductsUrl = "api/v1/OrderReleaseService/GetReleaseNumber";

export interface OrderReleaseProduct {
    ProductERPNumber: string;
    ReleasedQuantity: number;
    ProductMFGNumber: string;
    ProductDescriptionName: string;
}

export interface ReviewReleaseApiParameter {
    WebOrderNumber: string;
    ERPOrderNumber: string;
    ReleaseId: string;
    SalesWriterId: string;
    ReleaseDate: string;
    ReleaseNotes: string;
    ReleaseProductsList: OrderReleaseProduct[];
}
export interface ReviewReleaseResultModel {
    WebOrderNumber: string;
    ERPOrderNumber: string;
    ReleaseId: string;
    SalesWriterId: string;
    ReleaseDate: string;
    ReleaseNotes: string;
    ReleaseProductsList: OrderReleaseProduct[];
}
export interface Properties {}

export function ContactUsForm(
    parameter: ReviewReleaseApiParameter &
        HasOnSuccess<ReviewReleaseResultModel> &
        HasOnComplete<ReviewReleaseResultModel>,
) {
    const apiParameter = { ...parameter };
    delete apiParameter.onSuccess;
    delete apiParameter.onComplete;
    return post<ReviewReleaseResultModel>(autocompleteUrl, apiParameter);
}

export function ReviewReleasemail(parameter: ReviewReleaseResultModel) {
    return post<ReviewReleaseResultModel, void>(`${contactUS}`, parameter);
}

// Release number

export interface ReleaseNumberList extends ApiParameter, HasPagingParameters {
    WebOrderNumber: string | "";
    ERPOrderNumber: string | "";
}

export interface testParameter {
    orderReleaseNumber: string;
    isSuccess: boolean;
}

// export function getActiveReleaseNumber(parameter: ReleaseNumberList) {
//     const urlGetSubscriptionActive = `${getSubscriptionProductsUrl}/?UserProfileId=${parameter.WebOrderNumber}&CustomerId=${parameter.ERPOrderNumber}`;
//     console.log("urlGetSubscriptionActive", urlGetSubscriptionActive);
//     return urlGetSubscriptionActive;
// }

export async function getActiveReleaseNumber(parameter: ReleaseNumberList) {
    const urlGetSubscriptionActive = `${getSubscriptionProductsUrl}?WebOrderNumber=${parameter.WebOrderNumber}&ERPOrderNumber=${parameter.ERPOrderNumber}`;
    const responseData = await get<testParameter>(`${urlGetSubscriptionActive}`);
    return responseData;
}
